import { Column, Row } from "@/components/container/Container";
import { TextBodyMedium, TextHeadlineLarge, TextHeadlineSmall, TextLabelLarge2 } from "@/components/text/Texts";
import { Dialog } from "primereact/dialog";
import { BaseResponse, createTypedModal, GenericResponse, useTypedModal } from "@/common/common_utils";
import { X4bLocation } from "../../views/PlacesRepository";
import { useState } from "react";
import { PrimaryButtonMT, SecondaryButtonMT } from "@/components/buttons/Buttons";



interface Props { location: X4bLocation; }

const ConfirmAddressModal = createTypedModal<Props, boolean>((props: Props) => {
	const [isMapOpen, setIsMapOpen] = useState(false);
	const modal = useTypedModal<boolean>();

	const handleCancel = () => {
		modal.resolveRemove(false);
	};

	const handleConfirm = () => {
		modal.resolveRemove(true);
	};

	return (
		<Dialog
			unstyled
			onHide={handleCancel}
			visible={true}
			maskStyle={{ backgroundColor: '#00000047' }}
			pt={{
				root: { className: 'p-9 rounded-[28px] w-[600px] tablet:!max-w-[calc(100vw-6rem)] bg-surfaceContainer relative' },
				content: { className: 'p-0' },
				header: { className: 'absolute right-6 top-6' }
			}}
		>
			<Column className="relative gap-6 mb-9">
				<TextHeadlineLarge text="Select a location" className="text-primary" />
				<TextHeadlineSmall text={props.location.PlaceName} className="text-primary" />
				<TextBodyMedium text={props.location.Address} className="text-primary" />

			</Column>

			<Row className="gap-4 justify-end">
				<SecondaryButtonMT
					id="cancel"
					label="Cancel"
					className="!h-12 w-1/2"
					onClick={handleCancel}
				/>
				<PrimaryButtonMT
					id="add-group"
					label="Confirm Location"
					className="!h-12 w-1/2"
					onClick={handleConfirm}
				/>

			</Row>
		</Dialog>
	);
});

export default ConfirmAddressModal;
